<template>
  <main>
    <RouterView />
    <ConfirmDialog />
    <Toaster position="top-center" />
  </main>
</template>

<script setup lang="ts">
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { Toaster } from '@/components/ui/sonner'
</script>
